import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
    // List redemption products
    listRedemptionProductsLoading: false,
    listRedemptionProductsSuccess: false,
    listRedemptionProductsFail: false,
    listRedemptionProductsData: [],
    listRedemptionProductsErrorMessage: null,

    // Get redemption product detail
    getRedemptionProductDetailLoading: false,
    getRedemptionProductDetailSuccess: false,
    getRedemptionProductDetailFail: false,
    getRedemptionProductDetailData: null,
    getRedemptionProductDetailErrorMessage: null,

    // Redeem product
    redeemProductLoading: false,
    redeemProductSuccess: false,
    redeemProductFail: false,
    redeemProductData: null,
    redeemProductErrorMessage: null,

    // Get redemption history
    getRedemptionHistoryLoading: false,
    getRedemptionHistorySuccess: false,
    getRedemptionHistoryFail: false,
    // getRedemptionHistoryData: {
    //     data: [],
    //     currentPage: 1,
    //     totalPages: 0,
    //     totalItems: 0,
    //     hasMore: false,
    // },
    getRedemptionHistoryData: true,
    getRedemptionHistoryErrorMessage: null,

    // Get redemption order details
    getRedemptionOrderDetailsLoading: false,
    getRedemptionOrderDetailsSuccess: false,
    getRedemptionOrderDetailsFail: false,
    getRedemptionOrderDetailsData: null,
    getRedemptionOrderDetailsErrorMessage: null,

    // Confirm Receive
    confirmRedemptionReceiveLoading: false,
    confirmRedemptionReceiveSuccess: false,
    confirmRedemptionReceiveFail: false,
    confirmRedemptionReceiveErrorMessage: null,
}

export const redemptionProductsSlice = createSlice({
    name: "redemptionProducts",
    initialState,
    reducers: {
        // List Redemption Products Actions
        listRedemptionProductsRequest: (state) => {
            state.listRedemptionProductsLoading = true
            state.listRedemptionProductsSuccess = false
            state.listRedemptionProductsFail = false
            state.listRedemptionProductsErrorMessage = null
        },
        listRedemptionProductsSuccessAction: (state, action) => {
            state.listRedemptionProductsLoading = false
            state.listRedemptionProductsSuccess = true
            state.listRedemptionProductsFail = false
            state.listRedemptionProductsData = action.payload
            state.listRedemptionProductsErrorMessage = null
        },
        listRedemptionProductsFailAction: (state, action) => {
            state.listRedemptionProductsLoading = false
            state.listRedemptionProductsSuccess = false
            state.listRedemptionProductsFail = true
            state.listRedemptionProductsErrorMessage = action.payload
        },
        resetListRedemptionProducts: (state) => {
            state.listRedemptionProductsLoading = false
            state.listRedemptionProductsSuccess = false
            state.listRedemptionProductsFail = false
            state.listRedemptionProductsErrorMessage = null
        },

        // Get Redemption Product Detail Actions
        getRedemptionProductDetailRequest: (state) => {
            state.getRedemptionProductDetailLoading = true
            state.getRedemptionProductDetailSuccess = false
            state.getRedemptionProductDetailFail = false
            state.getRedemptionProductDetailErrorMessage = null
        },
        getRedemptionProductDetailSuccessAction: (state, action) => {
            state.getRedemptionProductDetailLoading = false
            state.getRedemptionProductDetailSuccess = true
            state.getRedemptionProductDetailFail = false
            state.getRedemptionProductDetailData = action.payload
            state.getRedemptionProductDetailErrorMessage = null
        },
        getRedemptionProductDetailFailAction: (state, action) => {
            state.getRedemptionProductDetailLoading = false
            state.getRedemptionProductDetailSuccess = false
            state.getRedemptionProductDetailFail = true
            state.getRedemptionProductDetailErrorMessage = action.payload
        },
        resetGetRedemptionProductDetail: (state) => {
            state.getRedemptionProductDetailLoading = false
            state.getRedemptionProductDetailSuccess = false
            state.getRedemptionProductDetailFail = false
            state.getRedemptionProductDetailData = null
            state.getRedemptionProductDetailErrorMessage = null
        },

        // Redeem Product Actions
        redeemProductRequest: (state) => {
            state.redeemProductLoading = true
            state.redeemProductSuccess = false
            state.redeemProductFail = false
            state.redeemProductErrorMessage = null
        },
        redeemProductSuccessAction: (state, action) => {
            state.redeemProductLoading = false
            state.redeemProductSuccess = true
            state.redeemProductFail = false
            state.redeemProductData = action.payload
            state.redeemProductErrorMessage = null
        },
        redeemProductFailAction: (state, action) => {
            state.redeemProductLoading = false
            state.redeemProductSuccess = false
            state.redeemProductFail = true
            state.redeemProductErrorMessage = action.payload
        },
        resetRedeemProduct: (state) => {
            state.redeemProductLoading = false
            state.redeemProductSuccess = false
            state.redeemProductFail = false
            state.redeemProductData = null
            state.redeemProductErrorMessage = null
        },

        // Get Redemption History Actions
        getRedemptionHistoryRequest: (state) => {
            state.getRedemptionHistoryLoading = true
            state.getRedemptionHistorySuccess = false
            state.getRedemptionHistoryFail = false
            state.getRedemptionHistoryErrorMessage = null
        },
        getRedemptionHistorySuccessAction: (state, action) => {
            const { data, appendData } = action.payload
            state.getRedemptionHistoryLoading = false
            state.getRedemptionHistorySuccess = true
            state.getRedemptionHistoryFail = false
            // state.getRedemptionHistoryData = data
            if (appendData) {
                // Append new data to existing (for load more)
                state.getRedemptionHistoryData.data = [
                    ...state.getRedemptionHistoryData.data,
                    ...data
                ]
            } else {
                // Replace data (for fresh load or filter change)
                state.getRedemptionHistoryData = data
            }

            state.getRedemptionHistoryData.currentPage = data.page
            state.getRedemptionHistoryData.totalPages = data.total_page
            state.getRedemptionHistoryData.totalItems = data.total_row
            state.getRedemptionHistoryData.hasMore = data.page < data.total_page
            state.getRedemptionHistoryErrorMessage = null
        },
        getRedemptionHistoryFailAction: (state, action) => {
            state.getRedemptionHistoryLoading = false
            state.getRedemptionHistorySuccess = false
            state.getRedemptionHistoryFail = true
            state.getRedemptionHistoryErrorMessage = action.payload
        },
        resetGetRedemptionHistory: (state) => {
            state.getRedemptionHistoryLoading = false
            state.getRedemptionHistorySuccess = false
            state.getRedemptionHistoryFail = false
            state.getRedemptionHistoryData = {
                data: [],
                currentPage: 1,
                totalPages: 0,
                totalItems: 0,
                hasMore: false,
            }
            state.getRedemptionHistoryErrorMessage = null
        },

        // Get Redemption Order Details Actions
        getRedemptionOrderDetailsRequest: (state) => {
            state.getRedemptionOrderDetailsLoading = true
            state.getRedemptionOrderDetailsSuccess = false
            state.getRedemptionOrderDetailsFail = false
            state.getRedemptionOrderDetailsErrorMessage = null
        },
        getRedemptionOrderDetailsSuccessAction: (state, action) => {
            state.getRedemptionOrderDetailsLoading = false
            state.getRedemptionOrderDetailsSuccess = true
            state.getRedemptionOrderDetailsFail = false
            state.getRedemptionOrderDetailsData = action.payload
            state.getRedemptionOrderDetailsErrorMessage = null
        },
        getRedemptionOrderDetailsFailAction: (state, action) => {
            state.getRedemptionOrderDetailsLoading = false
            state.getRedemptionOrderDetailsSuccess = false
            state.getRedemptionOrderDetailsFail = true
            state.getRedemptionOrderDetailsErrorMessage = action.payload
        },
        resetGetRedemptionOrderDetails: (state) => {
            state.getRedemptionOrderDetailsLoading = false
            state.getRedemptionOrderDetailsSuccess = false
            state.getRedemptionOrderDetailsFail = false
            state.getRedemptionOrderDetailsData = null
            state.getRedemptionOrderDetailsErrorMessage = null
        },

        // Confirm Receive Actions
        confirmRedemptionReceiveRequest: (state) => {
            state.confirmRedemptionReceiveLoading = true
            state.confirmRedemptionReceiveSuccess = false
            state.confirmRedemptionReceiveFail = false
            state.confirmRedemptionReceiveErrorMessage = null
        },
        confirmRedemptionReceiveSuccessAction: (state) => {
            state.confirmRedemptionReceiveLoading = false
            state.confirmRedemptionReceiveSuccess = true
            state.confirmRedemptionReceiveFail = false
            state.confirmRedemptionReceiveErrorMessage = null
        },
        confirmRedemptionReceiveFailAction: (state, action) => {
            state.confirmRedemptionReceiveLoading = false
            state.confirmRedemptionReceiveSuccess = false
            state.confirmRedemptionReceiveFail = true
            state.confirmRedemptionReceiveErrorMessage = action.payload
        },
        resetConfirmRedemptionReceive: (state) => {
            state.confirmRedemptionReceiveLoading = false
            state.confirmRedemptionReceiveSuccess = false
            state.confirmRedemptionReceiveFail = false
            state.confirmRedemptionReceiveErrorMessage = null
        },
    },
})

// Action creators
export const {
    listRedemptionProductsRequest,
    listRedemptionProductsSuccessAction,
    listRedemptionProductsFailAction,
    resetListRedemptionProducts,
    getRedemptionProductDetailRequest,
    getRedemptionProductDetailSuccessAction,
    getRedemptionProductDetailFailAction,
    resetGetRedemptionProductDetail,
    redeemProductRequest,
    redeemProductSuccessAction,
    redeemProductFailAction,
    resetRedeemProduct,
    getRedemptionHistoryRequest,
    getRedemptionHistorySuccessAction,
    getRedemptionHistoryFailAction,
    resetGetRedemptionHistory,
    getRedemptionOrderDetailsRequest,
    getRedemptionOrderDetailsSuccessAction,
    getRedemptionOrderDetailsFailAction,
    resetGetRedemptionOrderDetails,
    confirmRedemptionReceiveRequest,
    confirmRedemptionReceiveSuccessAction,
    confirmRedemptionReceiveFailAction,
    resetConfirmRedemptionReceive,
} = redemptionProductsSlice.actions

// Selectors
export const getListRedemptionProductsLoading = (state) => state.redemptionProducts.listRedemptionProductsLoading
export const getListRedemptionProductsSuccess = (state) => state.redemptionProducts.listRedemptionProductsSuccess
export const getListRedemptionProductsFail = (state) => state.redemptionProducts.listRedemptionProductsFail
export const getListRedemptionProductsData = (state) => state.redemptionProducts.listRedemptionProductsData
export const getListRedemptionProductsErrorMessage = (state) => state.redemptionProducts.listRedemptionProductsErrorMessage

export const getRedemptionProductDetailLoading = (state) => state.redemptionProducts.getRedemptionProductDetailLoading
export const getRedemptionProductDetailSuccess = (state) => state.redemptionProducts.getRedemptionProductDetailSuccess
export const getRedemptionProductDetailFail = (state) => state.redemptionProducts.getRedemptionProductDetailFail
export const getRedemptionProductDetailData = (state) => state.redemptionProducts.getRedemptionProductDetailData
export const getRedemptionProductDetailErrorMessage = (state) => state.redemptionProducts.getRedemptionProductDetailErrorMessage

export const getRedeemProductLoading = (state) => state.redemptionProducts.redeemProductLoading
export const getRedeemProductSuccess = (state) => state.redemptionProducts.redeemProductSuccess
export const getRedeemProductFail = (state) => state.redemptionProducts.redeemProductFail
export const getRedeemProductData = (state) => state.redemptionProducts.redeemProductData
export const getRedeemProductErrorMessage = (state) => state.redemptionProducts.redeemProductErrorMessage

export const getRedemptionHistoryLoading = (state) => state.redemptionProducts.getRedemptionHistoryLoading
export const getRedemptionHistorySuccess = (state) => state.redemptionProducts.getRedemptionHistorySuccess
export const getRedemptionHistoryFail = (state) => state.redemptionProducts.getRedemptionHistoryFail
export const getRedemptionHistoryData = (state) => state.redemptionProducts.getRedemptionHistoryData
export const getRedemptionHistoryErrorMessage = (state) => state.redemptionProducts.getRedemptionHistoryErrorMessage

export const getRedemptionOrderDetailsLoading = (state) => state.redemptionProducts.getRedemptionOrderDetailsLoading
export const getRedemptionOrderDetailsSuccess = (state) => state.redemptionProducts.getRedemptionOrderDetailsSuccess
export const getRedemptionOrderDetailsFail = (state) => state.redemptionProducts.getRedemptionOrderDetailsFail
export const getRedemptionOrderDetailsData = (state) => state.redemptionProducts.getRedemptionOrderDetailsData
export const getRedemptionOrderDetailsErrorMessage = (state) => state.redemptionProducts.getRedemptionOrderDetailsErrorMessage

export const getConfirmRedemptionReceiveLoading = (state) => state.redemptionProducts.confirmRedemptionReceiveLoading
export const getConfirmRedemptionReceiveSuccess = (state) => state.redemptionProducts.confirmRedemptionReceiveSuccess

// Thunks (API calls)

/**
 * Get list of all redemption products
 * @param {object} filters - { category, sortBy, pointType, minPoints, maxPoints }
 */
export const doListRedemptionProducts = (filters = {}) => {
    return async (dispatch) => {
        dispatch(listRedemptionProductsRequest())

        try {
            const params = new URLSearchParams()
            if (filters.category) params.append("category", filters.category)
            if (filters.sortBy) params.append("sortBy", filters.sortBy)
            if (filters.pointType) params.append("pointType", filters.pointType)
            if (filters.minPoints) params.append("minPoints", filters.minPoints)
            if (filters.maxPoints) params.append("maxPoints", filters.maxPoints)
            if (filters.size) params.append("size", filters.size)
            if (filters.page !== undefined) params.append("page", filters.page)

            // The "?" was missing, so any filter (e.g. sortBy) produced
            // /api/customer/redemption-productsortBy=... and the list failed to load.
            const query = params.toString()
            const response = await axios.get(
                `/api/customer/redemption-product${query ? `?${query}` : ""}`
            )

            dispatch(listRedemptionProductsSuccessAction(response.data.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(listRedemptionProductsFailAction(errorMessage))
        }
    }
}

/**
 * Get redemption product detail by ID
 * @param {string} productId - The redemption product ID
 */
export const doGetRedemptionProductDetail = (productId) => {
    return async (dispatch) => {
        dispatch(getRedemptionProductDetailRequest())

        try {
            const response = await axios.get(`/api/customer/redemption-product/${productId}`);

            dispatch(getRedemptionProductDetailSuccessAction(response.data.data))
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Network error occurred"
            dispatch(getRedemptionProductDetailFailAction(errorMessage))
        }
    }
}

/**
 * Redeem a product using points
 * @param {object} redeemData - { productId, quantity, pointType, deliveryAddress? }
 */
export const doRedeemProduct = (redeemData) => {
    return async (dispatch) => {
        dispatch(redeemProductRequest())

        try {
            const response = await axios.post(`/api/customer/redemption-product/redeem`, redeemData);

            dispatch(redeemProductSuccessAction(response.data.data))
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Network error occurred"
            dispatch(redeemProductFailAction(errorMessage))
        }
    }
}

/**
 * Redeem several products in one order.
 * @param {object} redeemData - { items: [{ productId, quantity }], ...shipping fields, notes }
 *
 * Reuses the single-redeem slice state (loading/success/fail) so any screen
 * already listening for a redemption result keeps working unchanged.
 */
export const doRedeemProductBulk = (redeemData) => {
    return async (dispatch) => {
        dispatch(redeemProductRequest())

        try {
            const response = await axios.post(`/api/customer/redemption-product/redeem-bulk`, redeemData);

            dispatch(redeemProductSuccessAction(response.data.data))
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Network error occurred"
            dispatch(redeemProductFailAction(errorMessage))
        }
    }
}

/**
 * Get user's redemption history
 * @param {object} filters - { status, startDate, endDate, size, page, appendData }
 */
export const doGetRedemptionHistory = (filters = {}) => {
    return async (dispatch) => {
        dispatch(getRedemptionHistoryRequest())

        try {
            const params = new URLSearchParams()
            if (filters.status) params.append("status", filters.status)
            if (filters.startDate) params.append("startDate", filters.startDate)
            if (filters.endDate) params.append("endDate", filters.endDate)
            if (filters.size) params.append("size", filters.size)
            if (filters.page !== undefined) params.append("page", filters.page)

            const response = await axios.get(`/api/customer/redemption-product/history?${params.toString()}`);

            dispatch(getRedemptionHistorySuccessAction({
                data: response.data,
                appendData: filters.appendData || false
            }))
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Network error occurred"
            dispatch(getRedemptionHistoryFailAction(errorMessage))
        }
    }
}

/**
 * Get redemption order details by ID
 * @param {number} orderId - The redemption order ID
 */
export const doGetRedemptionOrderDetails = (orderId) => {
    return async (dispatch) => {
        dispatch(getRedemptionOrderDetailsRequest())

        try {
            const response = await axios.get(`/api/customer/redemption-product/order/${orderId}`)
            dispatch(getRedemptionOrderDetailsSuccessAction(response.data.data))
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || "Network error occurred"
            dispatch(getRedemptionOrderDetailsFailAction(errorMessage))
        }
    }
}

/**
 * Confirm receive redemption order
 * @param {number} orderId - Redemption Order ID
 */
export const doConfirmRedemptionReceive = (orderId) => {
    return async (dispatch) => {
        dispatch(confirmRedemptionReceiveRequest())

        try {
            await axios.put(`/api/customer/redemption-product/order/${orderId}/confirm-receive`)
            dispatch(confirmRedemptionReceiveSuccessAction())
        } catch (error) {
            const errorMessage = error.response?.data?.errorMessage || error.message || "Network error occurred"
            dispatch(confirmRedemptionReceiveFailAction(errorMessage))
        }
    }
}

export default redemptionProductsSlice.reducer